var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgMoreHoriz = function SvgMoreHoriz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 20",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.667 10.833a.833.833 0 100-1.666.833.833 0 000 1.666zm5.833 0a.833.833 0 100-1.666.833.833 0 000 1.666zm5.833 0a.833.833 0 100-1.666.833.833 0 000 1.666z",
    stroke: "#48525C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgMoreHoriz;